import { render, staticRenderFns } from "./footerBar.vue?vue&type=template&id=58df3c9e&"
import script from "./footerBar.vue?vue&type=script&lang=js&"
export * from "./footerBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports